import type { ApiRoute, NoQueryParams } from "../api"
import type { FinancingChange } from "../vehicleDetails/overview/financing/FinancingChange"
import type { FinancingView } from "../vehicleDetails/overview/financing/FinancingView"

export interface ChangeFinancingPathParams {
	inventoryId: string
}

export const changeFinancingRoute: ApiRoute<ChangeFinancingPathParams, NoQueryParams, FinancingChange, FinancingView> =
	{
		buildUrl: (params) => `/vehicles/${params.inventoryId}/financing`,
		method: "post",
		path: "/vehicles/:inventoryId/financing",
	}
